import { useDispatch } from 'react-redux';
import { setPageTitle } from '../../redux/title/title.slice';
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Loader from '../../components/ui/loader';

function SubmitTicket() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(setPageTitle('Report an issue/ Submit a Query'));
  }, [dispatch]);

  const formUrl = 'https://forms.clickup.com/37343805/f/13kmhx-1848/2S6DKS7010SJM93EWE';

  return (
    <Box sx={{ position: 'relative', width: '100vw', height: 'calc(100vh - 56px)' }}>
      {loading && <Loader loading={true} message="Loading support form..." />}

      <iframe
        src={formUrl}
        title="ClickUp Support Form"
        frameBorder="0"
        onLoad={() => setLoading(false)}
        style={{
          width: '100',
          height: '100%',
          border: 'none',
          padding: 0,
          margin: 0,
          display: loading ? 'none' : 'block'
        }}
      />
    </Box>
  );
}

export default SubmitTicket;
